import { useQuery } from '@tanstack/react-query';
import { ultimoKmService, UltimoKm } from '../services/ultimoKm';

/**
 * O ultimo km do painel do veiculo escolhido, para a tela preencher o campo e
 * validar antes de enviar. `null` enquanto nao ha veiculo escolhido.
 */
export const useUltimoKm = (
  veiculoId: number | string | null | undefined,
  fonte: 'gestao' | 'portal' = 'gestao',
): { ultimo: UltimoKm | null; carregando: boolean } => {
  const id = veiculoId ? Number(veiculoId) : null;

  const { data, isLoading } = useQuery({
    queryKey: ['ultimo-km', fonte, id],
    queryFn: () => (fonte === 'portal' ? ultimoKmService.doVeiculoNoPortal(id!) : ultimoKmService.doVeiculo(id!)),
    enabled: id !== null && Number.isFinite(id) && id > 0,
    staleTime: 0,
  });

  return { ultimo: data ?? null, carregando: isLoading };
};

/** Mensagem de recusa local, igual a do servidor, ou null quando o km serve. */
export const erroDeKmMenor = (km: number | string | null | undefined, ultimo: UltimoKm | null): string | null => {
  if (!ultimo) return null;
  const valor = Number(km);
  if (!Number.isFinite(valor) || km === '' || km === null || km === undefined) return null;
  if (valor >= ultimo.km) return null;

  return `O painel deste veículo já marcou ${ultimo.descricao}. Informe um valor igual ou maior.`;
};
